import { Schema as S } from "effect";
export const Schema = S.Literal("paddle");
export const Value = "paddle";
